import React from 'react';

const ToolTipDescription = ({ text }) => {
	return <div className='tool-tip__description'>{text}</div>;
};

export default ToolTipDescription;
